<template>
  <div class="sp-template">
    <div class="h-title">区域</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
          <el-form-item label="仓库">
            <el-select filterable clearable v-model="conditions.warehouseCode" placeholder="请选择仓库">
              <el-option v-for="(d, i) in warehouseData" :key="i" :label="d.name" :value="d.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchTask()">搜 索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-button__groups">
        <div class="button-groups">
          <el-button v-if="in_configs(20201)" size="small" @click="addArea">新建区域</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" :data="tableData" stripe border style="width: 100%">
        <el-table-column label="仓库">
          <template slot-scope="scope">
            {{warehouseDataMaps[scope.row.warehouseCode]}}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="区域名称"></el-table-column>
        <el-table-column prop="label" label="区域编号"></el-table-column>
        <el-table-column prop="limitVolumeWeight" label="控制材积" :formatter="formatLimitVolumeWeight"></el-table-column>
        <el-table-column prop="recommendSpace" label="自动分配货拉" :formatter="formatRecommendSpace"></el-table-column>
        <el-table-column prop="pickOut" label="可以拣货" :formatter="formatPickOut"></el-table-column>
        <el-table-column prop="stockOut" label="可以发货" :formatter="formatStockOut"></el-table-column>
        <el-table-column prop="supportUrgentPickOut" label="支持优先级" :formatter="formatSupportUrgentPickOut"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-if="in_configs(20202)" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" size="mini" v-if="in_configs(20203)" @click="handleLook(scope.$index, scope.row)">查看</el-button>
            <!-- <i class="el-icon-delete" @click="handleDelete(scope.$index, scope.row)" title="删除"></i> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" 
      :current-page="currentPage" :page-sizes="[5, 10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="parseInt(total)">
      </el-pagination>
      <!-- 弹窗 -->
      <el-dialog :title="title" :visible.sync="dialogFormVisible" :before-close="emptyForm" @close="rulesForm('areaForm')" width="500px" top="5vh" class="fullwidth-form__dialog area-dialog">
        <el-form :model="areaForm" :rules="rules" ref="areaForm" size="small" label-width="130px">
          <div class="look" v-if="isLook">
            <el-form-item label="仓库">{{warehouseDataMaps[areaForm.warehouseCode]}}</el-form-item>
            <el-form-item label="区域编号">{{areaForm.label}}</el-form-item>
            <el-form-item label="宽度">{{areaForm.width}}</el-form-item>
            <el-form-item label="名称">{{areaForm.name}}</el-form-item>
            <el-form-item label="长度">{{areaForm.length}}</el-form-item>
            <el-form-item label="是否控制材积">{{areaForm.limitVolumeWeight ? '是' : '否'}}</el-form-item>
            <el-form-item label="是否自动分配货位">{{areaForm.recommendSpace ? '是' : '否'}}</el-form-item>
            <el-form-item label="是否可以捡货">{{areaForm.pickOut ? '是' : '否'}}</el-form-item>
            <el-form-item label="是否可以发货">{{areaForm.stockOut ? '是' : '否'}}</el-form-item>
            <el-form-item label="是否支持优先级">{{areaForm.supportUrgentPickOut ? '是' : '否'}}</el-form-item>
          </div>
          <div class="edit" v-else>
            <el-form-item label="仓库" prop="warehouseCode" label-width="80px">
              <el-select v-model="areaForm.warehouseCode" @change="checkLabel" :disabled="isEdit" clearable>
                <el-option v-for="(d, i) in warehouseData" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="isShow" label="区域编号" prop="label" label-width="80px">
            <!-- <el-form-item v-if="false" label="区域编号" prop="label"> -->
              <el-input v-model="areaForm.label" placeholder="区域编号" :disabled="isUsable"></el-input>
            </el-form-item>
            <el-form-item v-if="isShow2" label="区域编号" prop="label" label-width="80px">
              <el-input v-model="areaForm.label" placeholder="区域编号" :disabled="isEdit"></el-input>
            </el-form-item>
            <el-form-item label="宽度" prop="width" label-width="80px">
              <el-input v-model="areaForm.width" placeholder="宽度"></el-input>
            </el-form-item>
            <el-form-item label="名称" prop="name" label-width="80px">
              <el-input v-model="areaForm.name" placeholder="名称"></el-input>
            </el-form-item>
            <el-form-item label="长度" prop="length" label-width="80px">
              <el-input v-model="areaForm.length" placeholder="长度"></el-input>
            </el-form-item>
            <el-form-item label="是否控制材积">
              <el-switch v-model="areaForm.limitVolumeWeight"></el-switch>
            </el-form-item>
            <el-form-item label="是否自动分配货位">
              <el-switch v-model="areaForm.recommendSpace"></el-switch>
            </el-form-item>
            <el-form-item label="是否可以捡货">
              <el-switch v-model="areaForm.pickOut"></el-switch>
            </el-form-item>
            <el-form-item label="是否可以发货">
              <el-switch v-model="areaForm.stockOut"></el-switch>
            </el-form-item>
            <el-form-item label="是否支持优先级">
              <el-switch v-model="areaForm.supportUrgentPickOut"></el-switch>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="!isLook" size="small" @click="close('areaForm')">取 消</el-button>
          <el-button v-if="!isLook" size="small" type="primary" @click="createArea('areaForm')">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    var validWechatId = (rules, value, callback) => {
      let warehouseCode = this.areaForm.warehouseCode;
      if (value && warehouseCode != undefined && warehouseCode != "") {
        this.$request1({
          method: 'GET',
          url: '/area/check',
          params: {
            warehouseCode: warehouseCode,
            label: value
          }
        })
          .then(response => {
            if (response.data.success) {
              callback();
            } else {
              callback(new Error("该区域编号已存在！"));
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    };
    var validWidth = (rule, value, callback) => {
      let ref = /(^[1-9]([0-9]+)?(\.[0-9]+)?$)/;
      if (!ref.test(value)) {
        callback(new Error("宽应为大于0的数字"));
      } else {
        callback();
      }
    };
    var validLength = (rule, value, callback) => {
      let ref = /(^[1-9]([0-9]+)?(\.[0-9]+)?$)/;
      if (!ref.test(value)) {
        callback(new Error("长应为大于0的数字"));
      } else {
        callback();
      }
    };
    return {
      
      isUsable: false,
      isShow: false,
      isShow2: false,
      isEdit: false,
      status: 0,
      conditions: {
        warehouseCode: ""
      },
      title: "新建区域",
      isLook: false,
      tableData: [],
      warehouseCode: [],
      areaForm: {
        id: "",
        name: "",
        label: "",
        limitVolumeWeight: false,
        recommendSpace: false,
        pickOut: false,
        stockOut: false,
        supportUrgentPickOut: false,
        width: "",
        length: ""
      },
      warehouseData: [],
      warehouseDataMaps: {},
      currentPage: 1, //当前是第几页
      pageSize: 10, //每页显示记录个数
      total: 0,
      formLabelWidth: "120px",
      dialogFormVisible: false,
      filterText: "",
      rules: {
        warehouseCode: [
          {
            required: true,
            message: "请选择仓库",
            trigger: "change"
          }
        ],
        label: [
          {
            required: true,
            message: "请输入区域编号",
            trigger: "blur"
          },
          { validator: validWechatId, trigger: "blur" }
        ],
        name: [
          {
            required: true,
            message: "请输入区域名称",
            trigger: "blur"
          }
        ],
        width: [{ required: true, validator: validWidth, trigger: "blur" }],
        length: [{ required: true, validator: validLength, trigger: "blur" }]
      },
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  watch: {
    dialogFormVisible(val) {
      !val && (this.isLook = false);
    },
    filterText(val) {
      this.$refs.tree2.filter(val);
    }
  },
  components: {},
  created() {
    // this.initWarehouse();
    setTimeout(() => {
      this.initArea(null, this.currentPage, this.pageSize);
      this.getWarehouseData();
      
    }, 1000);
  },
  computed: {},
  methods: {
    getWarehouseData() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/warehouse/all',
        withCredentials: true
      })
        .then(response => {
          _this.warehouseData = response.data;
          if (_this.warehouseData.length > 0) {
            _this.warehouseData.forEach(c => {
              _this.warehouseDataMaps[c.id] = c.name;
            });
          }
        })
        .catch(error => {
          if (error.response && error.response.data) {
            _this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    // 初始化查询方法
    initArea(warehouseCode, currentPage, pageSize) {
      let _this = this;
      
      this.$request1({
        method: 'GET',
        url: '/area/query',
        params: {
          warehouseCode: _this.conditions.warehouseCode,
          currentPage: _this.currentPage,
          pageSize: _this.pageSize
        }
      })
        .then(response => {
          
          let data = response.data;
          if (data.success) {
            this.total = data.total;
            if (this.total > 0) {
              this.tableData = data.data;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    handleCheckChange(data, checked, indeterminate) {},

    addArea() {
      this.title = "新建区域";
      this.dialogFormVisible = true;
      this.isUsable = true;
      this.isShow = true;
      this.isShow2 = false;
      this.isEdit = false;
      this.status = 0;
    },
    checkLabel() {
      this.isUsable = false;
    },
    // 新建区域
    createArea(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.areaForm.categorys == "") {
            this.areaForm.categorys = null;
          }
          this.$request1({
            method: 'post',
            url: '/area/save',
            withCredentials: true,
            data: this.areaForm
          })
            .then(response => {
              this.dialogFormVisible = false;
              this.$refs[formName].resetFields();
              this.emptyForm();
              this.initArea("", this.currentPage, this.pageSize);
              this.success();
            })
            .catch(error => {
              console.log(error);
              this.$message.error("操作失败");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //操作成功
    success() {
      if (this.status == 1) {
        this.$message({
          message: "修改成功",
          type: "success",
          center: true,
          duration: 1500
        });
      } else {
        this.$message({
          message: "添加成功",
          type: "success",
          center: true,
          duration: 1500
        });
      }
    },
    //搜索
    searchTask() {
      this.currentPage = 1;
      let warehouseCode = this.conditions.warehouseCode.trim();

      this.initArea(warehouseCode, this.currentPage, this.pageSize);
    },
    //编辑
    handleEdit(index, row) {
      this.title = row ? "编辑区域" : "新建区域";
      this.dialogFormVisible = true;
      this.queryDetailData(row);
      this.isShow = false;
      this.isShow2 = true;
      this.isEdit = true;
      this.status = 1;
    },

    //查看
    handleLook(index, row) {
      this.title = "查看区域";
      this.dialogFormVisible = true;
      row && (this.isLook = true);
      this.queryDetailData(row);
    },
    queryDetailData(row) {
      this.areaForm.id = row.id;
      this.areaForm.warehouseCode = row.warehouseCode;
      this.areaForm.name = row.name;
      this.areaForm.label = row.label;
      this.areaForm.limitVolumeWeight = row.limitVolumeWeight;
      this.areaForm.recommendSpace = row.recommendSpace;
      this.areaForm.pickOut = row.pickOut;
      this.areaForm.stockOut = row.stockOut;
      this.areaForm.supportUrgentPickOut = row.supportUrgentPickOut;
      this.areaForm.width = row.width;
      this.areaForm.length = row.length;
    },
    //删除
    // handleDelete(index, row) {
    //   let self = this;
    //   console.log(index, row);
    //   this.$confirm("此操作将永久删除该区域, 是否继续?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning"
    //   })
    //     .then(_ => {
    //       this.$request1({
    //         method: 'GET',
    //         url: '/area/delete',
    //         params: {
    //           id: row.id
    //         }
    //       })
    //         .then(response => {
    //           self.tableData.splice(index, 1);
    //           this.$message({
    //             type: "success",
    //             message: "删除成功!"
    //           });
    //         })
    //         .catch(() => {
    //           this.$message({
    //             type: "info",
    //             message: "已取消删除"
    //           });
    //         });
    //     })
    //     .catch(_ => {});
    // },

    emptyForm() {
      this.areaForm.id = "";
      this.areaForm.warehouseCode = "";
      this.areaForm.name = "";
      this.areaForm.label = "";
      this.areaForm.limitVolumeWeight = false;
      this.areaForm.recommendSpace = false;
      this.areaForm.pickOut = false;
      this.areaForm.stockOut = false;
      this.areaForm.supportUrgentPickOut = false;
      this.areaForm.length = "";
      this.areaForm.width = "";
      this.dialogFormVisible = false;
    },
    rulesForm(formRule) {
      this.$refs[formRule].clearValidate();
    },
    formatLimitVolumeWeight(data) {
      return data.limitVolumeWeight == true ? "YSE" : "NO";
    },
    formatRecommendSpace(data) {
      return data.recommendSpace == true ? "YSE" : "NO";
    },
    formatPickOut(data) {
      return data.pickOut == true ? "YSE" : "NO";
    },
    formatStockOut(data) {
      return data.stockOut == true ? "YSE" : "NO";
    },
    formatSupportUrgentPickOut(data) {
      return data.supportUrgentPickOut == true ? "YSE" : "NO";
    },

    //清空验证
    close(formRule) {
      this.dialogFormVisible = false;
      this.$refs[formRule].resetFields();
      this.emptyForm();
    },

    //分页
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.initArea(null, this.currentPage, val);
    },
    handleCurrentChange(val) {
      this.currentPage = val
      
      this.initArea(null, val, this.pageSize);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.emptyForm();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/warehouse/area.vue